import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

const selectFlagsStore = ({ featureFlags }: RootState) => featureFlags;

export const selectFlags = createSelector(selectFlagsStore, ({ flags }) => flags);
